// How a library object is rendered: as a card in a list, as a folder tile, or as the
// header describing the parent of the file being viewed.
export type LibraryObjectViewType = "list" | "header" | "folder";

export const LibraryObjectViewType = {
  LIST: "list",
  HEADER: "header",
  FOLDER: "folder",
} as const satisfies Record<string, LibraryObjectViewType>;

export default LibraryObjectViewType;
